<template>
  <div class="bg-EXPONDO-white rounded-full border border-EXPONDO-primary-20">
    <div
      :style="{
        width: indicatorWidth,
        left: indicatorPosition
      }"
      class="relative bg-EXPONDO-primary-20 rounded-full border border-EXPONDO-primary-40 w-1/3 h-full"
    />
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'ScrollIndicator',
  props: {
    viewportWidth: {
      type: Number,
      required: true,
    },
    totalWidth: {
      type: Number,
      required: true,
    },
    position: {
      type: Number,
      required: true,
    },
  },
  setup(props) {

    const calculatePercentage = (value: number, total: number): string => {

      if (!value || !total) {

        return '0%';
      
      }
      const position = Math.min((value / total), 1);

      return `${position * 100}%`;
    
    };

    const indicatorWidth = computed<string>(() => {

      return calculatePercentage(props.viewportWidth, props.totalWidth);
    
    });
    const indicatorPosition = computed<string>(() => {

      return calculatePercentage(props.position, props.totalWidth);
    
    });

    return {
      indicatorWidth,
      indicatorPosition,
    };
  
  },
});

</script>
